import * as css from './EmailScreen.css';
import {useSelector} from 'react-redux';
import EmailImage from '../EmailImage';
import EmailDetails from '../EmailDetails';
import EmailButtons from '../emailButtons/EmailButtons';
import EmailArtist from '../emailArtist/EmailArtist';
import EditorWrapper from '../../../component/textEditor/editorWrapper/EditorWrapper';
import EyeHideSection from '../../components/eyeHideSection/EyeHideSection';
import {updateDesignEmail, updateEmailStatus} from '../../../redux/branding/brandingActions';
import EmailSubjectTextEditor from '../emailSubjectTextEditor/EmailSubjectTextEditor';
import ModeBtn from '../../../component/modeBtn/ModeBtn';
import ImageHeader from '../imageHeader/ImageHeader';
import {useTranslation} from 'react-i18next';
import CourseSection from '../courseBranding/courseSection/CourseSection';
import ParticipantSection from '../courseBranding/participantSection/ParticipantSection';
import {TState} from '../../../redux/store.type';
import {TBranding} from '../../../redux/branding/branding.type';
import {MESSAGE_TYPES} from '../menu/brandingConfig';
import {useBrandingParams} from '../../../hooks/useBrandingParams';

interface EmailScreenProps {
    type: 'ticket' | 'desperate' | 'billing';
}

function EmailScreen({type: emailType}: EmailScreenProps) {
    const {currentLang,data,getBrandingData} = useSelector((s:TState) => ({
        currentLang:s.branding.currentLang,
        data:s.branding.data,
        getBrandingData:s.branding.getBrandingData
    })) as TBranding;
    const {title,type: eventType}=useSelector((s:TState)=>({title:s.event.title,type:s.event.type}));
    // Use event type for course, otherwise use the prop type
    const type = eventType === 'course' ? 'course' : emailType;
    const {t} = useTranslation('branding');
    const {messageType} = useBrandingParams();
    const emailTicket = data?.[currentLang]?.emailTicket;
    const {emailDisplayQr, emailDisplayProducer}=data?.[currentLang]?.[messageType]??{};
    const texts = data?.[currentLang]?.[messageType]??{};
    const dependencies=[currentLang,getBrandingData[`${currentLang}XHR`], messageType];
    const emailStatus = emailType === 'ticket' ? emailTicket : data?.[currentLang]?.[messageType]?.enabledEmail;
    const updateStatus = async () => {
        const field = emailType === 'ticket' ? 'emailTicket' : 'enabledEmail';
        await  updateEmailStatus(field, emailStatus ===1?0:1, messageType);
    };
    const updateDisplayQr = async () => {
        await updateDesignEmail(messageType, {'emailDisplayQr': emailDisplayQr===1?0:1});
    };
    const updateDisplayProducer = async () => {
        await updateDesignEmail(messageType, {'emailDisplayProducer': emailDisplayProducer ===1?0:1});
    };
    const producers = eventType !== 'givechak' && emailType === 'ticket' ? <>
        <css.wrapModeBtn>
            <ModeBtn className={'small'} status={emailDisplayProducer} click={updateDisplayProducer} dataCyName={'displayProducer'} text={t('displayProducer')} requestStatus={undefined} dataTitle={undefined} disabled={false}/>
            {messageType=== MESSAGE_TYPES.sendTicket && <ModeBtn className={'small'} status={emailDisplayQr} click={updateDisplayQr} dataCyName={'displayQr'} text={t('addPDF')} requestStatus={undefined} dataTitle={undefined} disabled={false}/>}
        </css.wrapModeBtn></> : null;

    const compsType={
        course:{last:<>{messageType !== MESSAGE_TYPES.desperate && <CourseSection/>}<ParticipantSection/></>},
        ticket:{last:producers,buttons:messageType=== MESSAGE_TYPES.sendTicket?<EmailButtons/>:null,afterTitle:<EmailDetails />}
    };
    const updateEmail = (content)=>{
        // content=content.replaceAll('</p><p>','<br>').replaceAll('<p>','<br>').replaceAll('</p>','<br>');
        updateDesignEmail(messageType, {emailContent:content, content, mailingType: 'email'});
    };
    const imageText = messageType === MESSAGE_TYPES.sendTicket ? 'imageText' : 'emailImage';
    const comps=compsType[type]||compsType.ticket;
    const eyeSectionName = messageType === MESSAGE_TYPES.sendTicket ? 'title' : `${messageType}_title`;
    return (   
        <css.wrapper data-cy="emailScreen">
            <css.modeBtn>
                <ModeBtn className={'small'} status={emailStatus} click={updateStatus} dataCyName={'emailScreen'} requestStatus={undefined} dataTitle={undefined} text={undefined}/>
            </css.modeBtn>
            <EmailSubjectTextEditor name={'emailSubject'} dependencies={dependencies}/>
            <ImageHeader text={imageText}/>
            <css.container>
                <EmailImage name='imageMain'/>
                <EyeHideSection sectionName={eyeSectionName}>
                    <css.title>{title}</css.title>
                </EyeHideSection>
                {comps.afterTitle||''}
                <css.editor>
                    <EditorWrapper defaultText={texts.emailContent} events={{onSave: updateEmail}} lang={currentLang} dependencies={dependencies} limit={undefined}/>
                </css.editor>
                {comps.buttons||''}
            </css.container>
            <EmailArtist />
            {comps.last||''}
            {/* <SendMeTicket/> */}
        </css.wrapper>
    );
}

export default EmailScreen;
